<template>
  <div class="leco-content">
    <div class="page-title">トレーニングのフィードバックサマリー</div>

    <div v-show="mainLoading" class="initial-loader">loading...</div>
    <transition>
      <div v-show="!mainLoading" class="content-inner">
        <div class="row">
          <div class="pt-3 float-left col-lg-4">
            <p class="pb-0 mb-0 lh-125">
              <strong class="d-block text-gray-dark border-bottom border-gray">トレーニング名</strong>
              {{ trainingInfo.trainingPlanningName }}
            </p>
          </div>
          <div class="pt-3 float-left col-lg-4">
            <div class="pb-0 mb-0 lh-125">
              <strong class="d-block text-gray-dark border-bottom border-gray">講師名</strong>
              <div v-for="coach in trainingInfo.coaches" :key="coach.tpc_id">
                {{ coach.coach_name }}
              </div>
            </div>
          </div>
          <div class="pt-3 float-left col-lg-4">
            <p class="pb-0 mb-0 lh-125">
              <strong class="d-block text-gray-dark border-bottom border-gray">トレーニング日</strong>
              {{ trainingInfo.dateTimeFrom | moment("YYYY/MM/DD HH:mm") }} ～{{
                trainingInfo.dateTimeTo | moment("HH:mm")
              }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="pt-3 float-left col-lg-12">
            <p class="pb-0 mb-0 lh-125">
              <strong class="d-block text-gray-dark border-bottom border-gray">
                トレーニング資料
              </strong>
              <span v-if="
                trainingInfo.trainingMaterialUrl === null ||
                trainingInfo.trainingMaterialUrl === undefined ||
                trainingInfo.trainingMaterialUrl === ''
              ">
                （登録なし）
              </span>
              <span v-else-if="
                trainingInfo.trainingMaterialUrl
                  .toLowerCase()
                  .startsWith('https://')
              ">
                <a :href="trainingInfo.trainingMaterialUrl" target="_blank">
                  {{ trainingInfo.trainingMaterialUrl }}
                </a>
              </span>
              <span v-else>
                {{ trainingInfo.trainingMaterialUrl }}
              </span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="pt-3 float-left col-lg-12">
            <p class="pb-5 mb-0 lh-125">
              <strong class="d-block text-gray-dark border-bottom border-gray">
                トレーニング録画
              </strong>
              <span v-if="
                trainingInfo.recordingUrl === null ||
                trainingInfo.recordingUrl === undefined ||
                trainingInfo.recordingUrl === ''
              ">
                （録画なし）
              </span>
              <span>
                <router-link :to="{
                  name: 'web-meeting-rec-watch-redirect',
                  params: { id: trainingInfo.trainingPlanId }
                }" target="_blank">
                  {{ trainingInfo.recordingUrl }}
                </router-link>
              </span>
            </p>
          </div>
        </div>

        <div v-for="answerSummary in answerSummaries" :key="answerSummary.questionId" class="mb-5">
          <h5>
            {{ answerSummary.questionText }}
          </h5>

          <div v-if="answerSummary.datas.datasets[0].answerDetails.length > 0">
            <div v-if="answerSummary.questionType == 'radioButton'" class="float-left">
              <DoughnutChart :datas="answerSummary.datas" :options="options" class="doughnut-chart" />
            </div>
            <div v-else-if="answerSummary.questionType == 'dropDown'" class="float-left">
              <DoughnutChart :datas="answerSummary.datas" :options="options" class="doughnut-chart" />
            </div>
            <div class="animated chart-detail">
              <div class="content-txt">
                <table :class="[
                  answerSummary.questionType == 'textArea'
                    ? 'table table-striped table-hover table-sm text-detail-tbl'
                    : 'table table-striped table-hover table-sm value-detail-tbl'
                ]">
                  <thead>
                    <tr>
                      <td>氏名</td>
                      <td>回答内容</td>
                      <td>回答日時</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="answerDetail in answerSummary.answerDetails" :key="answerDetail.id">
                      <td class="full-name">{{ answerDetail.fullName }}</td>
                      <td class="text-val" v-text="answerDetail.answerValueName"></td>
                      <td class="date-time">
                        {{ answerDetail.answerDate | moment("YY/MM/DD HH:mm") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <dir class="clearfix"></dir>
          </div>
          <div v-else class="alert alert-secondary">
            まだ回答データがありません。
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import { API_BASE_URL } from "@/common/config";
import DoughnutChart from "@/components/LECO_DoughnutChart";
import moment from "moment";
import jQuery from "jquery";
global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

export default {
  name: "questionnaire-answer-summary",
  data() {
    return {
      trainingInfo: {},
      answerSummaries: [],
      mainLoading: true,
      options: {
        responsive: true,
        legend: {
          position: "right",
          labels: {
            fontSize: 17
          }
        }
      },
      logger: this.$store.state.logger
    };
  },
  filters: {
    moment(date, format) {
      return moment(date).format(format);
    }
  },
  components: {
    DoughnutChart
  },
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    const trainingPlanId = this.$route.params.id;
    const backgroundColorTemplate = [
      "#ed7300",
      "#ed8b2f",
      "#eda45f",
      "#edbc8e",
      "#edd5be",
      "#ede1d5"
    ];
    this.logger.info("アンケート回答サマリーを取得。ID=" + trainingPlanId);
    let api_url =
      API_BASE_URL +
      "training-plannings/" +
      trainingPlanId +
      "/questionnaire-answer-summary";
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((result) => {
        this.logger.debug("result:\n" + JSON.stringify(result));
        if ("statusCode" in result.data) {
          //statusCodeが200なら画面表示
          if (result.data.statusCode == 200) {
            this.logger.info("アンケート回答サマリー取得成功");
            this.logger.debug("getResult：" + JSON.stringify(result.data.body));

            // トレーニング基礎情報をセット
            this.trainingInfo = result.data.body.trainingInfo;

            //質問の回数分ループ
            for (let i = 0; i < result.data.body.answers.length; i++) {
              const question = result.data.body.answers[i];
              let graphData = {
                questionId: question.id,
                questionType: question.type,
                questionText: question.text,
                questionIsRequired: question.required,
                questionSortId: question.sortId,
                datas: {
                  labels: [],
                  datasets: [
                    {
                      data: [],
                      backgroundColor: [],
                      answerDetails: []
                    }
                  ]
                },
                answerDetails: question.answerDetails
              };

              // 回答の選択肢を設定
              let selections = [];
              if (
                question.type == "radioButton" ||
                question.type == "dropDown"
              ) {
                selections = question.selections;
              }
              // 回答の種類数ループ
              for (let j = 0; j < question.answerSummary.length; j++) {
                const answer = question.answerSummary[j];
                graphData.datas.datasets[0].data.push(answer.count);
                graphData.datas.datasets[0].backgroundColor.push(
                  backgroundColorTemplate[j]
                );
                graphData.datas.datasets[0].answerDetails =
                  question.answerDetails;

                //選択値から文字列を特定
                for (let k = 0; k < selections.length; k++) {
                  if (selections[k].id == answer.value) {
                    graphData.datas.labels.push(selections[k].text);
                  }
                }
              }
              this.answerSummaries.push(graphData);
            }
            this.logger.info(
              "アンケート回答をグラフ用変数にセット完了しました。"
            );
            this.mainLoading = false;
          } else {
            // 200以外はシステム例外画面表示
            this.logger.error(
              "API(get) return status code = " +
              result.data.statusCode +
              ", errorMessages=" +
              result.data.errorMessages
            );
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error(
            "API(get) return status code = " +
            result.data.statusCode +
            ", errorMessages=" +
            result.data.errorMessages
          );
          this.$router.push("/system-error500");
        }
      })
      .catch((error) => {
        this.logger.error("API(get) error");
        this.logger.error(error);
        this.$router.push("/system-error500");
      });
  },
  methods: {
    slideDetail: function (event) {
      // もっと見るボタンイベント設定
      global.$this = global.$(event.target);
      this.logger.info(global.$this.html());
      this.logger.info("clicked");
      if (global.$this.children().is(".open")) {
        global.$this.html("<p>閉じる</p>").addClass("close-btn");
        global.$this.parent().removeClass("slide-up").addClass("slide-down");
      } else {
        global.$this
          .html('<p class="open">もっと見る</p>')
          .removeClass("close-btn");
        global.$this.parent().removeClass("slide-down").addClass("slide-up");
      }
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  }
};
</script>

<style scoped>
.content-inner {
  padding: 15px;
}

.doughnut-chart {
  max-width: 400px;
  border: solid 1px #a7a7a7;
  padding: 20px;
}

.chart-detail {
  float: left;
}

.full-name {
  width: 170px;
}

.text-val {
  white-space: pre-line;
}

.date-time {
  width: 130px;
}

@media screen and (max-width: 450px) {
  .doughnut-chart {
    max-width: 96%;
    padding: 0px;
  }

  .content-wrap {
    width: 100%;
  }

  .value-detail-tbl {
    width: 100% !important;
    margin-left: 0px !important;
    margin-top: 15px;
  }

  .full-name {
    width: 70px;
  }

  .text-val {
    width: 240px;
  }

  .date-time {
    width: 70px;
  }
}

.value-detail-tbl {
  width: 460px;
  margin-left: 1rem;
}

.text-detail-tbl {
  width: 100%;
}

/*********************************************************************************** */
/* loadingアイコン用CSS */
.initial-loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: -webkit-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: linear-gradient(to right,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.initial-loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}

.initial-loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/*********************************************************************************** */
/* もっと見る用CSS */
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes slideDown {
  0% {
    opacity: 1;
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
  }

  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes slideDown {
  0% {
    opacity: 1;
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
  }

  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

.slide-down {
  -webkit-animation-name: slideDown;
  animation-name: slideDown;
}

@-webkit-keyframes slideUp {
  0% {
    -webkit-transform: translateY(20px);
    transform: translateY(20px);
  }

  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes slideUp {
  0% {
    -webkit-transform: translateY(20px);
    transform: translateY(20px);
  }

  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

.slide-up {
  -webkit-animation-name: slideUp;
  animation-name: slideUp;
}

.content-wrap {
  height: 250px;
  overflow: hidden;
  position: relative;
  margin: 0;
}

.close-btn,
.more-btn {
  display: block;
  width: 100%;
  padding: 70px 0 0;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  background: -moz-linear-gradient(top,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 60%);
  background: -webkit-linear-gradient(top,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 60%);
  background: linear-gradient(to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 60%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff',
      endColorstr='#ffffff',
      GradientType=0);
}

.close-btn {
  background: none;
}

.slide-up {
  height: 150px;
  padding-bottom: 0;
  overflow: hidden;
}

.slide-down {
  height: auto;
  overflow: visible;
  padding-bottom: 50px;
}

.more-btn p {
  display: inline-block;
  color: #fff;
  cursor: pointer;
  background: #6c757d;
  padding: 5px 20px;
  width: 80%;
  border-radius: 20px;
}

.close-btn {
  padding: 0;
}

.close-btn p {
  background: #aaa;
}
</style>
